import React, { useEffect, useState } from 'react'
import { postData } from '../../../js/helpers/apiHelper'

const rightArrow = (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1L7 7L0.999999 13"
      stroke="#002677"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
const leftArrow = (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 13L1 7L7 1"
      stroke="#002677"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

const NetworkPanel = ({ onChange, locationFindApi, dictionary }) => {
  const fetchData = async ({
    country = '',
    state = '',
    stateExists = 0,
    city = '',
  }) => {
    const payload = {
      country,
      state,
      stateExists,
      city,
    }

    try {
      const response = await postData(locationFindApi, payload)

      if (response.hasError) {
        throw new Error('Network response was not ok')
      }

      return response.data.records
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const [step, setStep] = useState(0)
  const [filter, setFilter] = useState({})
  const [countries, setCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState({})
  const [states, setStates] = useState([])
  const [selectedState, setSelectedState] = useState({})
  const [cities, setCities] = useState([])
  const [selectedCity, setSelectedCity] = useState({})
  const [locations, setLocations] = useState([])

  const handleSelect = (option) => {
    const newFilter = {
      country: '',
      state: '',
      stateExists: 0,
      city: '',
    }
    switch (step) {
      case 1:
        setSelectedCountry(option)
        setStep(option.stateExists ? 2 : 3)
        newFilter.country = option.value
        newFilter.stateExists = option.stateExists
        break

      case 2:
        setSelectedState(option)
        newFilter.country = selectedCountry.value
        newFilter.stateExists = 1
        newFilter.state = option.value
        setStep(3)
        break

      case 3:
        setSelectedCity(option)
        newFilter.country = selectedCountry.value
        newFilter.stateExists = selectedCountry.stateExists
        newFilter.state = selectedCountry.stateExists ? selectedState.value : ''
        newFilter.city = option.value
        setStep(4)
        break
      case 4:
        onChange(option)
        break

      default:
      // console.log('Step not recognized')
    }
    setFilter(newFilter)
  }

  const handleBack = () => {
    switch (step) {
      case 4:
        {
          setLocations([])
          setStep(3)
        }
        break

      case 3:
        {
          setCities([])
          setStep(selectedCountry.stateExists ? 2 : 1)
        }
        break

      case 2:
        {
          setStates([])
          setStep(1)
        }
        break

      default:
      // console.log('Step not recognized')
    }
  }

  const handleFetchData = async () => {
    const data = await fetchData(filter)
    // console.log('location-find', filter, data)
    switch (step) {
      case 2:
        setStates(
          data?.map((item) => ({
            value: item.State,
            text: item.StateName,
          }))
        )
        break
      case 3:
        setCities(
          data?.map((item) => ({
            value: item.City,
            text: item.City,
          }))
        )
        break
      case 4:
        setLocations(
          data?.map((item) => ({
            value: item.Code,
            text: item.Description,
            oagCode: item.OagCode,
            country: item.Country,
            countryName: item.CountryName,
            city: item.City,
          }))
        )
        break

      default:
      // console.log('Step not recognized')
    }
  }

  const initializeNetwork = async () => {
    setStep(1)
    if (countries?.length === 0) {
      const data = await fetchData({})
      setCountries(
        data?.map((item) => ({
          value: item.Country,
          text: item.CountryName,
          stateExists: item.StateExists,
        }))
      )
    }
  }

  useEffect(() => {
    if (step > 1) handleFetchData()
  }, [filter])

  // console.log('step', step)

  return (
    <div className="b-network-panel">
      {step === 0 && (
        <div className="b-network-panel__default">
          <p>{dictionary.searchGuide}</p>
          <button
            type="button"
            className="btn btn-primary js-prevent-propagation"
            onClick={initializeNetwork}>
            {dictionary.chooseFromNetwork}
          </button>
        </div>
      )}
      {step > 0 && (
        <div className="b-network-panel__menu">
          {step === 1 && (
            <Menu
              countriesHeader={dictionary.networkListHeader}
              options={countries}
              handleSelect={handleSelect}
            />
          )}
          {step === 2 && (
            <Menu
              header={selectedCountry.text}
              options={states}
              handleSelect={handleSelect}
              handleBack={handleBack}
            />
          )}
          {step === 3 && (
            <Menu
              header={
                selectedCountry.stateExists
                  ? selectedState.text
                  : selectedCountry.text
              }
              options={cities}
              handleBack={handleBack}
              handleSelect={handleSelect}
            />
          )}
          {step === 4 && (
            <Menu
              header={selectedCity.text}
              options={locations}
              handleBack={handleBack}
              handleSelect={handleSelect}
              noArrow
            />
          )}
        </div>
      )}
    </div>
  )
}

export default NetworkPanel

const Menu = ({
  handleBack,
  header,
  countriesHeader,
  options,
  handleSelect,
  noArrow = false,
}) => (
  <>
    {countriesHeader ? (
      <div className="b-network-panel__countries-header">{countriesHeader}</div>
    ) : (
      <button
        type="button"
        onClick={handleBack}
        className="btn b-network-panel__header js-prevent-propagation">
        {leftArrow}
        {header}
      </button>
    )}
    {options?.map((option) => (
      <>
        <input
          type="radio"
          class="js-prevent-propagation"
          id={option.value}
          key={option.value}
          value={option.value}
          onChange={() => {
            handleSelect(option)
          }}
        />
        <label htmlFor={option.value}>
          <div className="b-network-panel__option js-prevent-propagation">
            {option.text} {!noArrow && rightArrow}
          </div>
        </label>
      </>
    ))}
  </>
)
